<div class="collapsible-card">
  <button
    type="button"
    class="card-toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
  >
    <div class="toggle-left">
      <app-icon [type]="IconType.BUILDING" [size]="20"></app-icon>
      <span class="toggle-title">Adresse</span>
    </div>
    <app-icon
      [type]="IconType.CHEVRON_DOWN"
      [size]="20"
      [class.rotated]="isExpanded()"
    ></app-icon>
  </button>

  @if (isExpanded()) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="section-form">
      <div class="form-row three-col">
        <div class="form-group">
          <label for="addressStreet" class="form-label">Strasse</label>
          <input
            id="addressStreet"
            type="text"
            formControlName="addressStreet"
            class="form-input"
            [class.has-change]="isFieldChanged('addressStreet')"
            placeholder="z.B. Hauptstrasse"
            maxlength="200"
            autocomplete="street-address"
          />
          @if (hasError('addressStreet', 'maxlength')) {
            <span class="error-text">Höchstens {{ form.get('addressStreet')?.errors?.['maxlength'].requiredLength }} Zeichen erlaubt</span>
          }
        </div>

        <div class="form-group">
          <label for="addressHouseNumber" class="form-label">Hausnummer</label>
          <input
            id="addressHouseNumber"
            type="text"
            formControlName="addressHouseNumber"
            class="form-input"
            [class.has-change]="isFieldChanged('addressHouseNumber')"
            placeholder="z.B. 12a"
            maxlength="20"
          />
          @if (hasError('addressHouseNumber', 'maxlength')) {
            <span class="error-text">Höchstens {{ form.get('addressHouseNumber')?.errors?.['maxlength'].requiredLength }} Zeichen erlaubt</span>
          }
        </div>

        <div class="form-group">
          <label for="addressPostalCode" class="form-label">PLZ</label>
          <input
            id="addressPostalCode"
            type="text"
            formControlName="addressPostalCode"
            class="form-input"
            [class.has-change]="isFieldChanged('addressPostalCode')"
            placeholder="z.B. 20095"
            [attr.maxlength]="postalCodeFormat().maxLength"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="postal-code"
            (input)="onPostalCodeInput($event)"
          />
          @if (hasError('addressPostalCode', 'pattern')) {
            <span class="error-text">{{ postalCodeFormat().requirement }}</span>
          }
          @if (hasError('addressPostalCode', 'maxlength')) {
            <span class="error-text">Höchstens {{ form.get('addressPostalCode')?.errors?.['maxlength'].requiredLength }} Zeichen erlaubt</span>
          }
        </div>
      </div>

      <div class="form-row three-col">
        <div class="form-group col-span-2">
          <label for="addressCity" class="form-label">Ort</label>
          <input
            id="addressCity"
            type="text"
            formControlName="addressCity"
            class="form-input"
            [class.has-change]="isFieldChanged('addressCity')"
            placeholder="z.B. Hamburg"
            maxlength="200"
            autocomplete="address-level2"
          />
          @if (hasError('addressCity', 'maxlength')) {
            <span class="error-text">Höchstens {{ form.get('addressCity')?.errors?.['maxlength'].requiredLength }} Zeichen erlaubt</span>
          }
        </div>

        <div class="form-group">
          <label for="addressCountry" class="form-label">Land</label>
          <select
            id="addressCountry"
            formControlName="countrySelection"
            class="form-select"
            autocomplete="country"
            [class.is-empty]="!form.value.countrySelection"
            [class.has-change]="isFieldChanged('countrySelection')"
          >
            <option value="">Bitte wählen</option>
            @for (option of countryOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
      </div>

      @if (showManualCountry()) {
        <div class="form-row three-col">
          <div class="form-group">
            <label for="countryManual" class="form-label">ISO-Code</label>
            <input
              id="countryManual"
              type="text"
              formControlName="countryManual"
              class="form-input"
              [class.has-change]="isFieldChanged('countryManual')"
              placeholder="z.B. FR"
              maxlength="2"
              autocapitalize="characters"
              spellcheck="false"
            />
            @if (hasError('countryManual', 'pattern')) {
              <span class="error-text">Bitte einen 2-stelligen Landescode angeben</span>
            }
          </div>
        </div>
      }

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="toggleExpanded()"
          [disabled]="isSaving()"
        >
          {{ hasChanges() ? 'Verwerfen' : 'Abbrechen' }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!form.valid || isSaving() || !hasChanges()"
          [class.btn-loading]="isSaving()"
        >
          @if (isSaving()) {
            Speichern...
          } @else {
            Speichern
          }
        </button>
      </div>
    </form>
  }
</div>
